import {
  RequestTimeOffResponse as Response,
  TimeOffEvent,
  TimeOffQueryParams,
  convertTimeOffEvent,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useTimeOffRequest(params: TimeOffQueryParams, enabled = true) {
  const { server } = useServer()
  return useQuery<TimeOffEvent>({
    queryKey: keys.detail(params),
    queryFn: fetchTimeOffDetails,
    enabled,
  })

  async function fetchTimeOffDetails() {
    const response = await server.get<Response.TimeOffEvent>(getUrl(params))
    return convertTimeOffEvent(response)
  }
}

function getUrl(params: TimeOffQueryParams) {
  let url = '/v2/time_off'
  if ('id' in params) {
    url += '/' + params.id
  } else if ('uri' in params) {
    url = decodeURIComponent(params.uri!)
  }
  return url
}
